import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { InvoicesDetailService } from '../../services/api/invoices-detail.service';

interface InvoiceData {
  number: string; // invoiceID
  billingDate: Date;
  dueDate: Date;
  invoiceAmount: number; // tokenAmount
  status: string;
  isExpanded?: boolean;
  errors?: { date: string; cause: string; tokenAmount: string; billingDate?: string }[];
  paymentMethod?: string;
  paymentSources?: {
    myCash: string;
    myRewards: string;
    bankAccount: string;
    isDefaultToken?: boolean; 
  };
}

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrls: ['./invoices.component.scss']
})
export class InvoicesComponent implements OnInit {
  displayedColumns: string[] = ['number', 'billingDate', 'dueDate', 'invoiceAmount', 'status'];
  expandedDetailColumn = ['expandedDetail'];
  dataSource = new MatTableDataSource<InvoiceData>();
  selection = new SelectionModel<InvoiceData>(true, []);
  searchValue = '';
  invoiceType: string = 'outstanding';

  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;

  constructor(private invoicesDetailService: InvoicesDetailService) {}

ngOnInit(): void {
  const walletID = (sessionStorage.getItem('WalletID') || '').replace(/^"(.*)"$/, '$1');
  const walletRole = (sessionStorage.getItem('WalletRole') || '').replace(/^"(.*)"$/, '$1');
  const policyNumber = sessionStorage.getItem('policyNumber') || '';

  

  this.invoicesDetailService
    .fetchInvoiceDetails(walletID, walletRole, 'gw', policyNumber)
    .subscribe(
      response => {
        console.log('📦 Full API response:', response);

        const errors = response.errors || [];
         const invoiceList = response.result?.invoices || [];
        if (errors.length === 0) {
          console.warn('❗ No invoice errors found in response.');
        } else {
          console.log('✅ Invoice errors:', errors);
        }

              const transformedData: InvoiceData[] = errors.map((errorItem: any) => {
              const matchingInvoice = invoiceList.find((inv: any) => inv.invoiceNumber === errorItem.invoiceID  );
              const invoiceAmount = matchingInvoice?.invoiceAmount || parseFloat(errorItem.tokenAmount);

              const normalizedCardType = (errorItem.cardType || '').toLowerCase();
let cardImagePath = '';

switch (normalizedCardType) {
  case 'mastercard':
    cardImagePath = '../../../../assets/images/card/chkt_mastercard.svg';
    break;
  case 'visa':
    cardImagePath = '../../../../assets/images/card/chkt_visa.svg';
    break;
  case 'discover':
    cardImagePath = '../../../../assets/images/card/chkt_discover.svg';
    break;
  case 'amex':
  case 'americanexpress':
    cardImagePath = '../../../../assets/images/card/chkt_amex.svg';
    break;
  default:
    cardImagePath = ''; // fallback
}


        return {
          number: errorItem.invoiceID,
        billingDate: matchingInvoice ? new Date(matchingInvoice.invoiceBillDate + 'T12:00:00') : null,
          dueDate: new Date(errorItem.date), // payment failure date
          invoiceAmount: invoiceAmount,
          status: 'Failed',
          isExpanded: true,
          errors: [{
          date: errorItem.date,  // payment failure date
          cause: errorItem.error,
          tokenAmount: errorItem.tokenAmount,
          billingDate: matchingInvoice?.invoiceBillDate ? new Date(matchingInvoice.invoiceBillDate + 'T12:00:00') : null}],   
          paymentMethod: `${errorItem.cardType} ****${errorItem.last4Digits}`,
          paymentSources: {
            myCash: `$${errorItem.cashAmount}`,
            myRewards: errorItem.rewardsPoints,
            bankAccount: `****${errorItem.last4Digits}`,
             isDefaultToken: String(errorItem.isDefaultToken).toLowerCase() === 'true'
          },
           cardImage: cardImagePath 
        };
      });

        // ✅ ASSIGN TO TABLE
        this.dataSource = new MatTableDataSource(transformedData);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.dataSource.filterPredicate = (data: InvoiceData, filter: string) => {
          return (
            data.number.toLowerCase().includes(filter) ||
            data.status.toLowerCase().includes(filter) ||
            data.invoiceAmount.toString().includes(filter)
          );
        };
      },
      error => {
        console.error('❌ API call failed:', error);
      }
    );
}



  toggleExpand(row: InvoiceData): void {
    row.isExpanded = !row.isExpanded;
  }

  applySearch(search: string): void {
    this.dataSource.filter = search.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach(row => this.selection.select(row));
  }

  checkboxLabel(row?: InvoiceData): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.number}`;
  }
}
